import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import { ThemeProvider } from './hooks/useTheme';
import './index.css';

const CLERK_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!CLERK_KEY) {
  throw new Error('REACT_APP_CLERK_PUBLISHABLE_KEY is not set');
}

// Apply persisted theme before render to avoid flash
try {
  const t = localStorage.getItem('sera_theme') || 'dark';
  document.documentElement.classList.add(t);
  document.documentElement.style.colorScheme = t;
} catch {
  document.documentElement.classList.add('dark');
}

// ClerkProvider needs router-aware navigation (routerPush/routerReplace) so
// SignIn/SignUp internal step transitions (e.g. /sign-in -> /sign-in/factor-one)
// use React Router's client-side navigate() instead of falling back to a hard
// browser reload. Without this, Clerk has no way to update the URL without a
// full page navigation, which unmounts/remounts ClerkProvider mid-flow and can
// re-trigger the new-device email-code send twice — this is BrowserRouter must
// be OUTSIDE ClerkProvider so useNavigate() is available here.
function ClerkProviderWithRouter({ children }) {
  const navigate = useNavigate();
  return (
    <ClerkProvider
      publishableKey={CLERK_KEY}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
    >
      {children}
    </ClerkProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ClerkProviderWithRouter>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </ClerkProviderWithRouter>
  </BrowserRouter>
);

